

require('json2/json2');

require('es5-shim/es5-shim');

require('es5-shim/es5-sham');

require('EventShim/eventShim');

require('jqueryMask');


//////////////////
// WEBPACK FOOTER
// ./components/xo-ui-shims/dist/index.js
// module id = ./components/xo-ui-shims/dist/index.js
// module chunks = 0